import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Marks the search term a TLD-card click submitted, so the 1052/1053/1054 the
 * results page fires for it can carry is_tld_click and be told apart from a
 * typed gate search (both land on search_origin 'Domains gate').
 *
 * A singleton for the same reason as gateBiDedupService: the gate unmounts on
 * the route change to /results, so a ref would not survive the navigation the
 * click itself triggers.
 */
class TldClickSearchService {
  constructor() {
    _defineProperty(this, "_searchTerm", void 0);
  }
  mark(searchTerm) {
    this._searchTerm = searchTerm;
  }
  isTldClick(searchTerm) {
    return Boolean(searchTerm) && searchTerm === this._searchTerm;
  }
  reset() {
    this._searchTerm = undefined;
  }
}
export const tldClickSearchService = new TldClickSearchService();
//# sourceMappingURL=tldClickSearchService.js.map